import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Branch extends BaseEntity {

  id            : number;
  name          : string;
  branchCode    : string;
  phone         : string;
  email         : string;
  latitude      : number;
  longitude     : number;

  
  constructor() {
    super();
    this.name = "";
  }
}